<template>
    <svg :height="fullHeight" :viewBox="viewBox" xmlns="http://www.w3.org/2000/svg">

        <!-- Base color -->
        <rect :width="fullWidth" :height="fullHeight" :style="baseStyle"/>

        <!-- Inner colored field for mon -->
        <rect v-if="isMon" x="0" :y="fullHeight / 3" :width="fullWidth" :height="fullHeight / 3" :style="monStyle"/>

        <!-- Yellow stripes for 1-5 dan -->
        <rect v-if="yellowStripes" :x="stripeWidth" y="0" :width="stripeWidth" :height="fullHeight" :style="yellowFill"/>
        <rect v-if="yellowStripes > 1" :x="stripeWidth * 3" y="0" :width="stripeWidth" :height="fullHeight" :style="yellowFill"/>
        <rect v-if="yellowStripes > 2" :x="stripeWidth * 5" y="0" :width="stripeWidth" :height="fullHeight" :style="yellowFill"/>
        <rect v-if="yellowStripes > 3" :x="stripeWidth * 7" y="0" :width="stripeWidth" :height="fullHeight" :style="yellowFill"/>
        <rect v-if="yellowStripes > 4" :x="stripeWidth * 9" y="0" :width="stripeWidth" :height="fullHeight" :style="yellowFill"/>

        <!-- Red fields for 6-7 dan -->
        <rect v-if="redFields" :x="fullWidth / 5" :width="fullWidth/5" :height="fullHeight" :style="redFill"/>
        <rect v-if="redFields" :x="fullWidth * 3 / 5" :width="fullWidth/5" :height="fullHeight" :style="redFill"/>

        <!-- Number for 6-10 dan -->
        <text v-if="yellowNumber" :x="5" y="15" fill="yellow">{{ yellowNumber }}</text>
    </svg>
</template>

<script>
 export default {
     props: {
         rank: [String]
     },
     data() {
         return {
             fullWidth: 100,
             fullHeight: 20,
             stripeWidth: 5,
             yellow: 'yellow',
             orange: 'orange',
             green: 'green',
             blue: 'blue',
             brown: 'rgb(109,65,47)',
             red: 'rgb(182,0,0)'
         }
     },
     computed: {
       isOldRank() {
           return this.rank?.includes('-mon')
       },
       isMon() {
           return this.rank?.includes('mon')
       },
       danRank() {
         return this.rank?.includes('dan') ? this.rank?.match(/^\d+/).map(Number)[0] : 0
       },
       yellowStripes() {
         return this.danRank < 6 ? this.danRank : 0
       },
       redFields() {
         return this.rank === '6 dan' || this.rank === '7 dan'
       },
       yellowNumber() {
         return this.danRank > 5 ? this.danRank : 0
       },
       viewBox() {
         return `0 0 ${this.fullWidth} ${this.fullHeight}`
       },
       baseStyle() {
         return this.styleWithFill(this.baseColor)
       },
       monStyle() {
         return this.styleWithFill(this.monColor)
       },
       yellowFill() {
         return this.styleWithFill(this.yellow)
       },
       redFill() {
         return this.styleWithFill(this.red)
       },
       baseColor() {
         if (this.isOldRank) {
           return 'lightgray'
         }
         switch(this.rank) {
           case '5 mon':
           case '5 kyu':
               return this.yellow
           case '3 mon':
           case '4 kyu':
               return this.orange
           case '1 mon':
           case '3 kyu':
               return this.green
           case '2 kyu': return this.blue
           case '1 kyu': return this.brown
           case '1 dan':
           case '2 dan':
           case '3 dan':
           case '4 dan':
           case '5 dan':
           case '6 dan':
           case '7 dan':
               return 'black'
           case '8 dan':
           case '9 dan':
           case '10 dan':
               return this.red
           default: return 'white'
         }
       },
       monColor() {
         switch(this.rank) {
           case '5-mon': return this.yellow
           case '4-mon': return this.orange
           case '3-mon': return this.green
           case '2-mon': return this.blue
           case '1-mon': return this.brown
           case '6 mon': return this.yellow
           case '4 mon': return this.orange
           case '2 mon': return this.green
           default: return 'white'
         }
       }
     },
     methods: {
       styleWithFill(color) {
         return `fill:${color};stroke-width:1;stroke:black`
       }
     }
 }
</script>
